var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartState1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21.266px",
    height: "17.466px",
    viewBox: "0 0 21.266 17.466",
    enableBackground: "new 0 0 21.266 17.466",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#BCBCBC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10.688,3.291c0.953-1.744,2.823-2.729,4.924-2.576c2.182,0.159,4.057,1.558,4.715,3.481c0.451,1.316,0.23,2.562-0.379,3.778 c-0.916,1.83-2.281,3.374-3.876,4.72c-1.616,1.364-3.356,2.603-5.044,3.897c-0.222,0.171-0.412,0.262-0.714,0.059 c-2.851-1.912-5.539-3.981-7.651-6.607C1.782,8.949,1.054,7.78,0.778,6.417C0.383,4.453,1.515,2.324,3.492,1.313 c1.893-0.97,4.412-0.746,5.994,0.589C9.949,2.291,10.28,2.813,10.688,3.291z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartState1);
export default __webpack_public_path__ + "static/media/heart-state-1.9fae111467799758e141d23b92eb42b7.svg";
export { ForwardRef as ReactComponent };